import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setPorkFeedInformation, setPorkFeedInformationAdmin } from "services";

import { footprintingPorkPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_PORK_FEED_INFORMATION } from "consts";

import { UploadablePorkFeedInformation } from "models";

export const useMutateFootprintingPorkFeedInformation = (farmId: string, year: number, payload: UploadablePorkFeedInformation[], primaryDataId: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_PORK_FEED_INFORMATION, primaryDataId, isAdmin],
      mutationFn: () => (isAdmin ? setPorkFeedInformationAdmin(primaryDataId, payload) : setPorkFeedInformation(primaryDataId, payload)),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_PORK_FEED_INFORMATION, primaryDataId, isAdmin],
          ...footprintingPorkPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
